export default "<p>\n  footcard works!\n</p>\n";